import { useSelector } from "react-redux";

import Login from "../pages/auth/Login";
import PropTypes from 'prop-types';

const ProtectedRoute = ({ children }) => {

    const { isAuthenticated, isLoggedIn } = useSelector((state) => state.auth);

    return (isAuthenticated && isLoggedIn) ? children : <Login />;
}

ProtectedRoute.propTypes = {
    children: PropTypes.node.isRequired,
};

export default ProtectedRoute;